import { getData } from "../../api";

export const getUserSearchSuggestions = async (term) => {
  if (!term || !term.trim()) return [];

  const res = await getData(
    `/admin/offline-order/searchUsers?term=${encodeURIComponent(term)}`,
  );

  return res?.success && Array.isArray(res.data) ? res.data : [];
};